function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Person_svg__15_a"
}, React.createElement("stop", {
  stopColor: "#A6D4FA",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#63DFA8",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
  fill: "url(#Person_svg__15_a)"
}), React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M24 35.819c-.649.119-1.317.181-2 .181-6.075 0-11-4.925-11-11s4.925-11 11-11a11 11 0 019.798 6H26a2 2 0 00-2 2v13.819zM14 24c.04 2.238 1.826 4.024 4 4 2.174.024 3.96-1.762 4-4-.045-2.235-1.828-4.018-4-4-2.177-.03-3.966 1.76-4 4zm.49 5.67c1.62 2.586 4.458 4.208 7.51 4.21a9.15 9.15 0 002-.21c-.84-2.75-2.57-5-6-5a5.75 5.75 0 00-3.51 1z",
  opacity: 0.504
}), React.createElement("path", {
  d: "M27 22h10a1 1 0 011 1v6a1 1 0 01-1 1H27a1 1 0 01-1-1v-6a1 1 0 011-1zm0 10h10a1 1 0 011 1v2a1 1 0 01-1 1H27a1 1 0 01-1-1v-2a1 1 0 011-1zm1.5-8a.5.5 0 000 1h7a.5.5 0 100-1h-7zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 7a.5.5 0 100 1h6a.5.5 0 100-1h-6z"
})));

var SvgPerson = function SvgPerson(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: 50,
    height: 50
  }, props), _ref, _ref2);
};

export default SvgPerson;